import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectParentPorgrammeId } from "reducers/customFields";
import { customField } from "./model";
import { useFormikContext } from "formik";
import { ProjectSetUpDetails } from "pages/Projects/models";

const useProgrammeFilter = (
  customFields: customField[],
  parentProgrammeId: number | null,
  readOnly: boolean,
  bFiltered: boolean | undefined
) => {
  const [filteredCustomFields, setFilteredCustomFields] = useState<
    customField[]
  >([]);
  const [currentProgrammeId, setCurrentProgrammeId] = useState<number | null>(
    null
  );
  const { values } = useFormikContext<ProjectSetUpDetails>();

  useEffect(() => {
    if (
      typeof values === "object" &&
      values.hasOwnProperty("parentProgrammeId") &&
      values.parentProgrammeId !== currentProgrammeId
    ) {
      setCurrentProgrammeId(values.parentProgrammeId);
    }
  }, [values]);

  useEffect(() => {
    if (!bFiltered || readOnly) {
      if (
        customFields &&
        Array.isArray(customFields) &&
        customFields.length > 0
      ) {
        setFilteredCustomFields([...customFields]);
      } else {
        setFilteredCustomFields([]);
      }
      return;
    }
    if (currentProgrammeId && values.listParentProgrammes) {
      const availableCustomFields = values.listParentProgrammes.find(
        element => element.value === currentProgrammeId
      )?.customFieldsIDs;
      if (availableCustomFields) {
        setFilteredCustomFields(
          customFields.filter(field => availableCustomFields.includes(field.id))
        );
      } else {
        setFilteredCustomFields([]);
      }
    } else {
      setFilteredCustomFields([]);
    }
  }, [currentProgrammeId]);

  return filteredCustomFields;
};

export default useProgrammeFilter;
